import { AdminModuleService } from '@sdk-point/talisis';
import * as b2bPermissionsTypes from '../types/b2bPermissionsTypes';

// Mismo patrón de instanciación que en ModuleManagement.jsx: el primer
// argumento es la CLAVE de entorno (keyof API_URLS), no una URL completa.
const AdminModuleServiceSDK = new AdminModuleService(
    process.env.REACT_APP_ENV_V2,
    process.env.REACT_APP_X_API_KEY_V2
);

export const loadB2BPermissions = (personId) => async (dispatch) => {
    dispatch({ type: b2bPermissionsTypes.LOAD_B2B_PERMISSIONS_START });

    try {
        // getModulePermissions -> GET /{ENV}/admin/modules/permissions/{personId}
        // Devuelve { success, message, scope, modules }.
        const data = await AdminModuleServiceSDK.getModulePermissions(personId);

        dispatch({
            type: b2bPermissionsTypes.LOAD_B2B_PERMISSIONS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: b2bPermissionsTypes.LOAD_B2B_PERMISSIONS_ERROR,
            payload: error.response?.data?.message || error.message,
        });
    }
};
